import {
    sortAscFamiliar
} from '../../../business-components/Sort/Sort'



const processaFormRegistrosDefaultIniciais = (values, total, processaRegistrosDefaultIniciais) => {
 
    total?.forEach( (linhaTotal, indexTotal) => {

        processaRegistrosDefaultIniciais(values, linhaTotal.id)
    })
}

export const processaFormSortAscFamiliar = (despesaReceita) => {
 
    if (despesaReceita) {
        
        despesaReceita = sortAscFamiliar(despesaReceita)
    }
}

export const processaFormRegistrosDefaultIniciaisSortAscFamiliar = (values, total, processaRegistrosDefaultIniciais, despesaReceita) => {
 
    processaFormRegistrosDefaultIniciais(values, total, processaRegistrosDefaultIniciais)

    processaFormSortAscFamiliar(despesaReceita)
}